<div class="ticket-container">
  <div
    *ngFor="let result of actionResults"
    class="ticket-result"
    [class.ticket-result-success]="isSuccess(result)"
    [class.ticket-result-error]="!isSuccess(result)"
  >
    <div class="ticket-title">{{ result.ticket.title }}</div>
    <div class="ticket-summary" *ngIf="summary(result.ticket)">
      {{ summary(result.ticket) }}
    </div>

    <!-- listed here rather than through <messages>: that one reads the
         controls of a form, and there is no form on this screen -->
    <ul class="ticket-problems" *ngIf="!isSuccess(result)">
      <li *ngFor="let problem of problems(result)">{{ problem | translate }}</li>
    </ul>
  </div>
</div>

<div class="finish-row" *ngIf="actionResults.length > 0">
  <button (click)="finish()" class="finish-button">
    {{ "process.finish" | translate }}
  </button>
  <span class="finish-summary">{{ changeSummary }}</span>
</div>
